<div class="confirm-modal">
  @if (effectiveIcon !== 'none') {
    <div
      class="confirm-modal-icon"
      [class.confirm-modal-icon--info]="effectiveIcon === 'info'"
      [class.confirm-modal-icon--error]="effectiveIcon === 'error'"
      aria-hidden="true"
    >
      @if (effectiveIcon === 'warning') {
        <svg viewBox="0 0 24 24" width="26" height="26" fill="none">
          <path d="M12 3 1.5 21h21L12 3Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
          <path d="M12 9.5v5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          <circle cx="12" cy="17" r="1" fill="currentColor" />
        </svg>
      } @else if (effectiveIcon === 'error') {
        <svg viewBox="0 0 24 24" width="26" height="26" fill="none">
          <circle cx="12" cy="12" r="9.2" stroke="currentColor" stroke-width="1.6" />
          <path d="m8.6 8.6 6.8 6.8M15.4 8.6l-6.8 6.8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
        </svg>
      } @else {
        <svg viewBox="0 0 24 24" width="26" height="26" fill="none">
          <circle cx="12" cy="12" r="9.2" stroke="currentColor" stroke-width="1.6" />
          <path d="M12 11v5.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          <circle cx="12" cy="7.6" r="1" fill="currentColor" />
        </svg>
      }
    </div>
  }

  <h4 class="confirm-modal-title">{{ title }}</h4>

  <div class="confirm-modal-body">
    @if (paragraphs?.length) {
      @for (p of paragraphs; track p) {
        <p>{{ p }}</p>
      }
    } @else {
      <p>{{ message }}</p>
    }
  </div>

  <div class="confirm-modal-actions">
    @if (showCancel) {
      <button type="button" class="btn btn-outline" [disabled]="isLoading" (click)="cancel()">{{ cancelLabel }}</button>
    }
    <button
      type="button"
      class="btn"
      [class.btn-danger]="confirmVariant === 'danger'"
      [class.btn-theme]="confirmVariant === 'theme'"
      [disabled]="isLoading"
      (click)="onConfirm()"
    >
      @if (isLoading) {
        <span class="confirm-modal-spinner" aria-hidden="true"></span>
      }
      {{ confirmLabel }}
    </button>
  </div>
</div>
